import type { PropsWithChildren, ReactNode } from 'react';
import { useIsGlobalHydrationComplete } from './useIsGlobalHydrationComplete.tsx';

/**
 * Renders children when hydration has completed globally (all subtrees have hydrated).
 * Will never render children if page is not hydrated.
 */
export const RenderAfterGlobalHydrationCompletion = ({
	children,
}: PropsWithChildren): ReactNode => {
	const isCompleted = useIsGlobalHydrationComplete();
	if (!isCompleted) {
		return null;
	}
	return children;
};
